import React, { useEffect, useRef, useState, useContext } from 'react';
import QuestionsList from './QuestionsList';
import LoadingSpinner from '../library/LoadingSpinner';
import { BluebookContext } from '../state/BluebookContext';

const ReviewPage = (props) => {
  const { learnosityApp } = props;
  const sectionRef = useRef();
  const [showSpinner, setShowSpinner] = useState(false);
  const { state: playerState } = useContext(BluebookContext);
  const { isLearnosityApiReady } = playerState;

  useEffect(() => {
    const hasRefreshed = localStorage.getItem('isReviewPage');
    if (hasRefreshed) {
      setShowSpinner(true);
    }

    if (isLearnosityApiReady) {
      setShowSpinner(false);
    }
  }, [isLearnosityApiReady]);

  useEffect(() => {
    sectionRef.current.focus();
  }, [sectionRef]);

  useEffect(() => {
    localStorage.setItem('isReviewPage', 'true');

    return () => {
      localStorage.removeItem('isReviewPage');
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      tabIndex={-1}
      aria-label="Section page"
      className="bluebook-review-page h-full bg-gray-100 flex flex-col items-center"
    >
      <h1 className="font-normal leading-normal mx-0 my-2 pt-6">
        Check Your Work
      </h1>
      <p className="leading-normal my-2 mx-0">
        Click on any question to return to it and review your answer.
      </p>
      <p className="leading-normal my-3 mx-0">
        Click <strong>Submit</strong> when you have completed the assignment.
      </p>
      {showSpinner ? (
        <LoadingSpinner />
      ) : (
        <div className="bb-desktop:shadow-[0_8px_16px_0_rgba(30,30,30,.15)] bb-desktop:bg-white bb-desktop:w-[766px] bb-desktop:rounded-2xl mt-3">
          <QuestionsList learnosityApp={learnosityApp} />
        </div>
      )}
    </section>
  );
};

export default ReviewPage;
